<template>
  <div class="datagrid-select" v-loading="isLoading">
    <div class="datagrid-select__header">{{ title }}</div>
    <div class="datagrid-select__container" v-if="!isLoading">
      <div class="datagrid-select__search">
        <el-input
          placeholder="Поиск по атрибуту"
          class="r-input"
          size="mini"
          v-model="filterInput"
          suffix-icon="el-icon-search"
        >
        </el-input>
        <el-select
          v-if="simple"
          v-model="label"
          size="mini"
          class="r-select"
          placeholder="Type"
          no-match-text="Нет совпадений"
          filterable
        >
          <el-option
            v-for="subitem in labels"
            :key="subitem"
            :label="subitem"
            :value="subitem"
          ></el-option>
        </el-select>
      </div>
      <div class="datagrid-select__list-block">
        <ul class="datagrid-select__list">
          <el-row class="datagrid-select__row">
            <el-col class="datagrid-select__cell header" :span="16">ID</el-col>
            <el-col class="datagrid-select__cell header" :span="8">{{
              returnShortProperty(label)
            }}</el-col>
          </el-row>
          <li
            :class="getClassName(item.id)"
            @click="changeActive(item)"
            v-for="item in currentPageData"
            :key="item.id"
          >
            <el-row class="datagrid-select__row">
              <el-col class="datagrid-select__cell" :span="16">
                <span>{{ item.id }}</span>
              </el-col>
              <el-col class="datagrid-select__cell" :span="8">
                <span style="margin-left:5px">{{
                  item[returnShortProperty(label)]
                }}</span>
              </el-col>
            </el-row>
          </li>
        </ul>
        <el-pagination
          layout="prev, pager, next"
          :small="true"
          @current-change="changeCurrentPage"
          :page-size="pageSize"
          :total="itemsCount"
        >
        </el-pagination>
      </div>
      <div class="datagrid-select__actions">
        <el-button
          class="r-button danger"
          size="mini"
          type="danger"
          @click="cancelEditing"
          >Закрыть</el-button
        >
        <el-button
          class="r-button main"
          size="mini"
          type="success"
          @click="saveValue"
          >{{ simple ? "Сохранить" : "Применить" }}</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
const getCoords = elem => {
  // get element coordinates in window
  const box = elem.getBoundingClientRect();
  return {
    top: box.top + pageYOffset,
    left: box.left + pageXOffset
  };
};

export default {
  props: ["select-data", "select-coords"],
  data() {
    return {
      type: "",
      foreign_key: "",
      primary_key: "",
      row: {},
      property: "",
      label: "",
      filterInput: "",
      title: "",
      labels: [],
      data: [],
      selected: [],
      isLoading: false,
      coords: {
        left: this.selectData.simple
          ? "calc(50% - 175px)"
          : "calc(50% - 115px)",
        top: this.selectData.simple ? "calc(50% - 185px)" : "calc(50% - 265px)"
      },
      currentPage: 1,
      pageSize: this.selectData.simple ? 5 : 8
    };
  },
  computed: {
    currentPageData() {
      // getter for current page data
      const index = (this.currentPage - 1) * this.pageSize;
      return this.filteredData.slice(index, index + this.pageSize);
    },
    itemsCount() {
      // all items count
      return this.filteredData.length;
    },
    filteredData() {
      // get filtered data (filter by search value)
      return (
        this.data.filter(
          item =>
            String(item[this.returnShortProperty(this.label)]).indexOf(
              this.filterInput
            ) > -1
        ) || []
      );
    }
  },
  methods: {
    changeCurrentPage(currentPage) {
      // change current page in pagination
      this.currentPage = currentPage;
    },
    getClassName(id) {
      // get active/notactive classname in values list
      if (this.type === "belongs_to") {
        const value = this.simple
          ? this.selected[0].id
          : this.selected
          ? this.selected.id
          : null;
        return value === id
          ? "datagrid-select__item active"
          : "datagrid-select__item";
      } else {
        return this.selected.findIndex(item => item.id === id) > -1
          ? "datagrid-select__item active"
          : "datagrid-select__item";
      }
    },
    changeActive(object) {
      // change active item/items in list (belongs_to / has_many)
      if (this.type === "belongs_to") {
        this.selected = !this.simple
          ? {
              id: object.id,
              [this.primary_key]: object[this.primary_key],
              [this.property]: object[this.returnShortProperty(this.label)]
            }
          : [{ ...object }];
      } else {
        const index = this.selected.findIndex(item => item.id === object.id);
        const shortProp = this.returnShortProperty(this.label);
        const newObject = !this.simple
          ? { id: object.id, [this.property]: object[shortProp], new: true }
          : { ...object };
        if (index > -1) {
          this.selected.splice(index, 1);
        } else {
          this.selected.push(newObject);
        }
      }
    },
    saveValue() {
      // save value - emitting to parent saveSelect event
      const value =
        this.type === "belongs_to" ? this.selected : [...this.selected];
      this.$emit("saveSelect", value);
    },
    cancelEditing() {
      // cancel -  emitting to parent cancelSelect event
      this.$emit("closeSelect");
    },
    returnShortProperty(label) {
      // helper for getting shortProperty 'from_links_edit_no' -> 'no'
      if (this.simple) {
        return label;
      } else {
        const arr = label.split("/");
        return arr[arr.length - 1];
      }
    },
    dragHandler(e) {
      // drag handler for window
      const select = e.target.parentNode;
      const container = select.parentNode;
      const coords = getCoords(select);
      const containerCoords = getCoords(container);
      const shiftX = e.pageX - coords.left;
      const shiftY = e.pageY - coords.top;
      const moveAt = e => {
        this.coords.left = e.pageX - shiftX - containerCoords.left + "px";
        this.coords.top = e.pageY - shiftY - containerCoords.top + "px";
      };
      document.onmousemove = e => moveAt(e);
      e.target.onmouseup = function() {
        document.onmousemove = null;
        e.target.onmouseup = null;
      };
    }
  },
  mounted() {
    const select = document.querySelector(".datagrid-select__header");
    if (select) select.addEventListener("ondragstart", () => false);
  },
  watch: {
    selectData: {
      // watcher for selectData (changing by cell clicking)
      handler: async function(val) {
        const {
          source_id,
          type,
          row,
          property,
          foreign_key,
          primary_key,
          label,
          simple
        } = val;
        let data;
        this.isLoading = true;
        if (!this.$clientStore.isDataInStore(source_id)) {
          ({ data } = await this.$store.dispatch("REQUEST", {
            url: `objectInfo/${source_id}`
          }));
          this.$clientStore.insertData(source_id, data);
        } else {
          data = this.$clientStore.getData(source_id);
        }
        this.data = Object.keys(data).map(id => data[id]);
        this.type = type;
        this.foreign_key = foreign_key;
        this.primary_key = primary_key;
        this.property = property;
        this.label = this.returnShortProperty(val.label);
        this.row = row;
        this.isLoading = false;
        this.simple = simple;
        this.title = label;
        if (this.simple) {
          this.labels = this.$clientStore
            .getDataFields(source_id)
            .filter(field => !field.source_id && field.title !== "id")
            .map(field => field.title);
          this.label = this.labels[0];
          this.selected = this.type === "belongs_to" ? this.row : [...this.row];
        } else
          this.selected =
            this.type === "belongs_to"
              ? this.row[this.property]
              : [...this.row[this.property]];
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style lang="scss">
.datagrid-select {
  font-size: 12px;
  position: absolute;
  height: 520px;
  width: 330px;
  background-color: var(--white_white);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: auto;
  z-index: 2000;
  box-shadow: 1px 1px 8px rgba(var(--black), 0.3);

  &__header {
    background-color: var(--accent_primary) !important;
    height: 20px;
    padding: 5px 10px;
    color: var(--white_white);
    font-weight: bold;
  }

  &__search {
    display: flex;
    flex-shrink: 0;

    .r-select {
      margin-left: 10px;
    }
  }

  &__container {
    padding: 10px;
    display: flex;
    flex-direction: column;
    height: calc(100% - 30px);
    box-sizing: border-box;
  }

  &__list-block {
    margin: 10px 0;
    border: 1px solid;
    border-radius: var(--border-radius);
    flex: 1;
    overflow: auto;
    border-color: var(--dividers_low_contrast) !important;
  }

  &__list {
    overflow-y: auto;
  }

  &__row {
    border-bottom: 1px solid;
    border-color: var(--dividers_low_contrast) !important;
  }

  &__cell {
    &.header {
      padding: 5px 0;
      font-weight: bold;
      font-size: 12px;
      padding-bottom: 5px;
      text-align: center;
      background-color: var(--bg_containers) !important;
    }
    padding: 2px;

    &:first-child {
      border-right: 1px solid;
      border-color: var(--dividers_low_contrast) !important;
    }
  }

  &__item {
    cursor: pointer;
    &.active {
      background-color: var(--accent_primary) !important;
      color: var(--white_white) !important;
    }
  }

  &__actions {
    display: flex;
    justify-content: space-between;
  }

  .el-pagination {
    text-align: center;

    button:hover {
      color: var(--accent_primary) !important;
    }

    .el-pager li {
      &:hover {
        color: var(--accent_primary) !important;
      }
      &.active {
        color: var(--accent_primary) !important;
      }
    }
  }
}

.simple .datagrid-select {
  height: 370px;
  width: 350px;
}
</style>
